import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=3f5e6265&scoped=true"
import script from "./Storage.vue?vue&type=script&lang=ts"
export * from "./Storage.vue?vue&type=script&lang=ts"
import style0 from "./Storage.vue?vue&type=style&index=0&id=3f5e6265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e6265",
  null
  
)

export default component.exports